<template>
<div>
  <div style="margin-bottom:10px;">
    <span>{{completion.optionContent}}</span>
  </div>

  <div class="accuracy-precision-completion-wrapper">
    <label>理论浓度</label>
    <label>:</label>
    <input v-model="completion.theoryValue" type="number" @input="onInput" />
    <span style="padding-left:5px;">ppb/ppbC</span>

    <template v-for="(n, index) in 7">
      <label :key="`${n}-label`">{{n === 1 ? '分析仪响应浓度' : ''}}</label>
      <label :key="`${n}-:`">{{n === 1 ? ':' : ''}}</label>
      <input :key="`${n}-input`" v-model="inputValues[index]" type="number" @input="onInput" />
      <span :key="`${n}-unit`" style="padding-left:5px;">ppb/ppbC</span>
    </template>

    <label>{{label}}</label>
    <label>:</label>
    <div>
      <span>{{Number.isFinite(calcValue) ? `${(calcValue * 100).toFixed(2)}%` : '--'}}</span>
      <span
        v-if="isCompleted"
        :style="{color: isQualified ? 'green' : 'red'}"
        class="diff"
      >{{isQualified ? '合格' : '不合格'}}</span>
    </div>
  </div>
</div>
</template>

<script>
import BaseFormula from './BaseFormula'
import FormulaMode from '../../../../model/FormulaMode'

export default {
  name: 'AccuracyPrecisionCompletion',
  extends: BaseFormula,
  data: () => ({
    inputValues: new Array(7).fill(NaN)
  }),
  computed: {
    label: () => '',
    calcValue () {
      return this.completion.value
    },
    finiteTheoryValue () {
      return Number.isFinite(parseFloat(this.completion.theoryValue))
    },
    allInput () {
      return !this.inputValues.some(value => !Number.isFinite(parseFloat(value)))
    },
    isCompleted () {
      return this.finiteTheoryValue && this.allInput
    },
    isQualified () {
      return FormulaMode[this.$options.name].isQualified(this.completion)
    }
  },
  methods: {
    setParam (completion) {
      completion.isCompleted = this.isCompleted
      completion.isQualified = this.isQualified
    },
    onInput () {
      let {completion, inputValues} = this

      completion.inputValue = inputValues.join('|')
      completion.value = this.isCompleted ? FormulaMode[this.$options.name].getValue(completion) : null
      completion.resultValue = this.isQualified | 0

      this.setParam(completion)
      this.$emit('complete-change')
    }
  },
  created () {
    let {completion} = this

    // if (measureInstruments.length > 0 && !completion.hasOwnProperty('taskMeasureInstrumentId')) {
    //   this.$set(completion, 'taskMeasureInstrumentId', measureInstruments[0].id)
    // }

    if (!completion.hasOwnProperty('value')) {
      this.$set(completion, 'value', null)
    }

    let inputValues = (this.completion.inputValue || '').split('|')

    for (let i = inputValues.length; i < 7; i++) {
      inputValues.push(NaN)
    }

    this.inputValues = inputValues

    this.onInput()
  }
}
</script>

<style lang="scss" scoped>
.accuracy-precision-completion-wrapper {
  display: grid;
  grid-template-columns: repeat(4, max-content);
  grid-row-gap: 5px;
  align-items: center;

  > label {
    text-align: justify;
    text-align-last: justify;

    & + :not(label) {
      margin-left: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Data/TaskResult/Completion/AccuracyPrecisionCompletion.vue